import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';

import Editor from '../../../ApplicationForm/Editor';
import { debounce, LabelName, Required, validateCustomFields } from '../../../../../utils';

export function Paragraph({
  data,
  setData,
  setError,
  ind,
  isRequired,
  globalStateData,
  setCustomFieldsValidation,
}) {
  const [value, setValue] = useState(globalStateData?.customFormData?.[ind]?.fieldValue ?? '');
  const [error1, setError1] = useState('');

  const isDisabled =
    globalStateData?.customFormData?.[ind]?.isEditable !== undefined
      ? !globalStateData?.customFormData?.[ind]?.isEditable
      : false;

  const debouncedValidation = useCallback(
    debounce((fieldData, setError2) => {
      const resp = validateCustomFields(fieldData);
      if (!resp.isValid) {
        setError2(resp.errorMessage);
        setCustomFieldsValidation((prev) => ({
          ...prev,
          [data?.fieldName]: false,
        }));
      } else {
        setError2('');
        setCustomFieldsValidation((prev) => ({
          ...prev,
          [data?.fieldName]: true,
        }));
      }
      if (fieldData.value === '') setError2('');
    }, 350),
    [],
  );

  useEffect(() => {
    setError(null);
    if (isRequired && !value.trim()) {
      setError(`Field ${ind + 1} is required.`);
      return;
    }
    // setData(value, ind);

    const match = value.match(/<p>(.*?)<\/p>/i);
    const textValue = match ? match[1] : '';

    setData(textValue, ind);
  }, [value]);

  const handleInputChange = (text) => {
    const match = text.match(/<p>(.*?)<\/p>/i);
    const extractedText = match ? match[1] : '';
    setValue(text);
    setError1('');

    const { fieldType, paragraphValidation, required } = data;
    const fieldData = {
      fieldType,
      paragraphValidation,
      required,
      value: extractedText,
    };

    debouncedValidation(fieldData, setError1);
  };

  return (
    <Grid container style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Grid item>
        <LabelName>
          {data?.fieldName}
          {isRequired && <Required> *</Required>}
        </LabelName>
      </Grid>
      <Grid item style={{ width: 'inherit' }}>
        <Editor
          wrapperId={data?.fieldName}
          placeholder="Type here"
          description={value}
          onChangeSelection={handleInputChange}
        />
        {/* <QuillEditor
          placeholder="Type here"
          description={value}
          onChangeSelection={handleInputChange}
          readOnly={isDisabled}
        /> */}
      </Grid>
      {error1 && <span style={{ color: 'red', fontSize: '0.9rem' }}>{error1}</span>}
    </Grid>
  );
}

export default Paragraph;
